import * as React from 'react';

import CommonLearningPathDataProvider from 'bundles/enterprise-learning-path-description-page/providers/CommonLearningPathDataProvider';

const EnterpriseLearningPathPageDirectorDataProvider = ({ children }: { children: React.ReactNode }) => {
  return <CommonLearningPathDataProvider>{children}</CommonLearningPathDataProvider>;
};

export default EnterpriseLearningPathPageDirectorDataProvider;
